import { Link } from "react-router-dom";
import {t} from "i18next";

interface StockManagementNavigationProps {
  selectedIndex: number;
}

const StockManagementNavigation: React.FunctionComponent<
StockManagementNavigationProps
> = ({
  selectedIndex = 0
}) => {
  return (
    <div className="tabnavigation">
      <Link to="/stock/list" className={"tabnavigation__item " + (selectedIndex === 0 ? "active" : "")}>
        <div className="tabnavigation__item-content">
          {t("Stock")}
        </div>
      </Link>
      <Link to="/stock/orders/pending" className={"tabnavigation__item " + (selectedIndex === 1 ? "active" : "")}>
        <div className="tabnavigation__item-content">
          {t("Pending orders")}
        </div>
      </Link>
      <Link to="/stock/orders/list" className={"tabnavigation__item " + (selectedIndex === 2 ? "active" : "")}>
        <div className="tabnavigation__item-content">
          {t("Order history")}
        </div>
      </Link>
    </div>
  );
};

export default StockManagementNavigation;
